export const replacePathParams = (path, params) => {
  return path.replace(/:(\w+)/g, (_, key) => {
    if (!params[key]) {
      throw new Error(`Missing parameter ${key} in path ${path}`);
    }
    return params[key];
  });
};
